/**
 * Chi crea la palestra entra da un link suo.
 *
 * Il link di accesso al pilot va a tutti — atleti compresi — e da lì si arriva
 * alla stessa schermata iniziale. Finché quella schermata offriva «Crea una
 * palestra come coach», un atleta poteva fondarne una per sbaglio e restare
 * chiuso in una palestra vuota, senza accorgersene: non è un errore che
 * l'applicazione sappia annullare da sola.
 *
 * L'edge riconosce un secondo percorso, con un token proprio, e su quel
 * dispositivo lascia questo contrassegno. Non è una credenziale: il cookie che
 * autorizza le richieste resta `HttpOnly` e non passa mai di qui. È solo il
 * segno che quel dispositivo ha aperto il link riservato al coach, ed è
 * leggibile da JavaScript proprio perché deve poter decidere cosa mostrare.
 */
export const COACH_ENTRY_COOKIE = "palestra_coach";

export function coachEntryGranted(cookie: string = document.cookie): boolean {
  return cookie
    .split(";")
    .map((entry) => entry.trim())
    .includes(`${COACH_ENTRY_COOKIE}=1`);
}
